/**
 * @file: 图纸渲染模式判断
 * @author: xiaolong.huang@dmall.com
 */

import Config from '../../config/index';

// 文字模式
export function isTxTModel(): boolean {
    let renderModel: RenderModel = Config.getGlobalConfig('RENDER_MODEL');

    return renderModel === 0;
}

// 图片模式
export function isPicModel(): boolean {
    let renderModel: RenderModel = Config.getGlobalConfig('RENDER_MODEL');

    return renderModel === 1;
}

// 突出显示模式
export function isColorModel(): boolean {
    let renderModel: RenderModel = Config.getGlobalConfig('RENDER_MODEL');

    return renderModel === 2;
}
